export default  {
    component: 'plant_device_report',
    name: 'plant_device_report',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Device Type',
            param: 'device_type',
            type: 'text',
            description: `Options are provided. For each device a new row should be added with plant Id.
            - Energy Meter
            - Inverter
            - MFM
            - Weather Station
            - SCB
            - MPPT
            - Transformer
            - Soil Sensor
            - Relay
            - Ups
            - Breaker
            - Annunciator`
          },
          {
            name: 'Visibility',
            param: 'visibility',
            type: 'json',
            description: `Json need to be add. Make specific report as false if not required.
            - {"advancedReport": {"plantSummaryReport": true, "deviceLevelPerformanceReport": true, "deviceLevelDailyGenerationReport": true}}`
          }
    ]
  }
